import * as React from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
/**
 * set up a interval which is cleared automatically when the component unmounts
 * @param time the time in ms between each time the callback is fired
 * @param callback the callback to run after the given time
 */

export function useInterval(callback, time, config) {
  var interval = React.useRef();
  var clear = React.useCallback(function () {
    clearInterval(interval.current);
  }, []);
  var set = React.useCallback(function (overrideCallback, overrideTime) {
    clear();
    interval.current = setInterval(overrideCallback !== null && overrideCallback !== void 0 ? overrideCallback : callback, overrideTime !== null && overrideTime !== void 0 ? overrideTime : time);
  }, [time, callback]);
  useDidUpdateEffect(function () {
    if (interval.current) {
      set();
    }
  }, [callback]);
  React.useEffect(function () {
    if (config === null || config === void 0 ? void 0 : config.setOnMount) {
      set();
    }

    return function () {
      clear();
    };
  }, []);
  return {
    set: set,
    clear: clear
  };
}